import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { BLACK_900, getTestId, Typography } from '@airtel/air-design-system';
import { getTimerStyles } from './TimerStyles';
var Timer = props => {
  var _props$timerInSeconds = props.timerInSeconds,
    timerInSeconds = _props$timerInSeconds === void 0 ? 0 : _props$timerInSeconds,
    onUserAction = props.onUserAction,
    onTimerFinishMetaData = props.onTimerFinishMetaData,
    id = props.id,
    testID = props.testID,
    _props$timerTypograph = props.timerTypographyProps,
    timerTypographyProps = _props$timerTypograph === void 0 ? {} : _props$timerTypograph,
    _props$trailingText = props.trailingText,
    trailingText = _props$trailingText === void 0 ? '' : _props$trailingText,
    _props$isIncreasingTi = props.isIncreasingTimer,
    isIncreasingTimer = _props$isIncreasingTi === void 0 ? false : _props$isIncreasingTi;
  var _useState = useState(timerInSeconds),
    totalSeconds = _useState[0],
    setTotalSeconds = _useState[1];
  var styles = getTimerStyles();
  useEffect(() => {
    var interval;
    if (totalSeconds > 0) {
      interval = setInterval(() => {
        setTotalSeconds(prevTotalSeconds => isIncreasingTimer ? prevTotalSeconds + 1 : prevTotalSeconds - 1);
      }, 1000);
    } else {
      clearInterval(interval);
      onTimerFinishMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onTimerFinishMetaData), props));
    }
    return () => clearInterval(interval);
  }, [totalSeconds]);
  var getTimerText = () => {
    var hours = Math.floor(totalSeconds / 3600);
    var remainingSeconds = totalSeconds % 3600;
    var minutes = Math.floor(remainingSeconds / 60);
    var seconds = remainingSeconds % 60;
    var displayMinutes = "" + (minutes < 10 ? '0' : '') + minutes;
    var displaySeconds = "" + (seconds < 10 ? '0' : '') + seconds;
    var displayHours = "" + (hours < 10 ? '0' : '') + hours;
    return displayHours + ":" + displayMinutes + ":" + displaySeconds + " " + trailingText;
  };
  return timerInSeconds ? _jsx(View, Object.assign({
    style: styles.timerText
  }, {
    children: _jsx(Typography, Object.assign({
      text: "" + getTimerText(),
      type: "body-single-line-sm-bold",
      color: BLACK_900
    }, getTestId(testID, 'Typography'), timerTypographyProps))
  })) : null;
};
export default Timer;